import { envTag, isProd } from "../env";

/**
 * Persistent non-production warning. Renders nothing in prod -- production is
 * the quiet baseline, so the bar never becomes something people learn to
 * ignore because it is always there.
 *
 * Not dismissible: the risk it guards against is exactly the moment someone
 * has stopped paying attention.
 *
 * Amber (`--amber`), not red: `--red` is already the error colour throughout
 * the portal, and a red bar on every page would read as "something is broken"
 * rather than "you are somewhere else".
 */
export function EnvBanner() {
  if (isProd()) return null;

  return (
    <div className="env-banner" data-testid="env-banner">
      <strong>NON-PRODUCTION — {envTag()} ENVIRONMENT</strong>
      <span>
        Test data. Reports go to FINTRAC&rsquo;s test endpoint and are not filed.
      </span>
    </div>
  );
}
